export default __webpack_public_path__ + "static/media/minus_icon_Normal.b831cd37.svg";